import { RemoteCourseGetById } from 'data/usecases';
import { makeApiUrlCourse } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCourseGetById = (): RemoteCourseGetById => {
  return new RemoteCourseGetById(makeApiUrlCourse(), makeAxiosHttpClient());
};
